/**
 * Per-browser user preferences edited on /settings (Notifications, Preferences tabs).
 * Stored in localStorage only; guarded so unavailable or corrupt storage yields defaults.
 */
export const PREFS_KEY = 'ultimate-gis:prefs:v1';
export const MAP_VIEWS = ['map', 'satellite', 'topo'];

export const DEFAULT_PREFS = Object.freeze({
  defaultMapView: 'map',
  demoMode: false, // Cape Cod sample data on the map; off unless the user opts in
  notifications: Object.freeze({ qc: true, upload: true, weekly: false }),
});

export function loadPrefs(storage) {
  try {
    const s = storage || window.localStorage;
    const raw = JSON.parse(s.getItem(PREFS_KEY) || 'null');
    if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return { ...DEFAULT_PREFS, notifications: { ...DEFAULT_PREFS.notifications } };
    const n = raw.notifications && typeof raw.notifications === 'object' ? raw.notifications : {};
    return {
      defaultMapView: MAP_VIEWS.includes(raw.defaultMapView) ? raw.defaultMapView : DEFAULT_PREFS.defaultMapView,
      demoMode: raw.demoMode === true,
      notifications: {
        qc: typeof n.qc === 'boolean' ? n.qc : DEFAULT_PREFS.notifications.qc,
        upload: typeof n.upload === 'boolean' ? n.upload : DEFAULT_PREFS.notifications.upload,
        weekly: typeof n.weekly === 'boolean' ? n.weekly : DEFAULT_PREFS.notifications.weekly,
      },
    };
  } catch {
    return { ...DEFAULT_PREFS, notifications: { ...DEFAULT_PREFS.notifications } };
  }
}

/** Returns true when the preferences were written. */
export function savePrefs(prefs, storage) {
  try {
    const s = storage || window.localStorage;
    s.setItem(PREFS_KEY, JSON.stringify(prefs));
    return true;
  } catch {
    return false;
  }
}
